/**
 * Maintenance Query Hook
 *
 * React Query hook for maintenance status polling.
 * Scoped to components that need it (landing page) instead of global polling.
 */

import { useQuery } from '@tanstack/react-query';
import { getMaintenanceStatus } from '@/services/maintenance.api';

/** Polling interval in milliseconds (30 seconds) */
const POLL_INTERVAL_MS = 30_000;

export function useMaintenanceQuery() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['maintenance', 'status'],
    queryFn: getMaintenanceStatus,
    refetchInterval: POLL_INTERVAL_MS,
    refetchIntervalInBackground: true,
    placeholderData: (prev) => prev
  });

  return {
    isActive: data?.status.isActive ?? false,
    isPreparing: (data?.status.isPreparing && !data.status.isActive) ?? false,
    isLoading,
    error,
    cachedAt: data?.cachedAt ?? null
  };
}
